import { WellEventData, WellNoteSaveData } from '../../components/add-wellnote-modal/WellEventData';
import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

export const saveWellNoteData = async (wellNoteData: WellNoteSaveData, isPC: boolean, assetId?: string): Promise<WellEventData | null> => {
  try {
    const { WellId, WellGroupId, Note, NoteDate, CategoryId, WellNoteId } = wellNoteData;
    if (isPC && !WellId && (!WellGroupId || WellGroupId === 0)) {
      return null;
    }

    const noteDateObj = new Date(NoteDate);

    const formattedDate = formatNoteDate(noteDateObj); // e.g. 'YYYY-MM-DD'
    if (isPC) {
      const formData = new URLSearchParams();

      if (WellNoteId) formData.append('WellNoteId', String(WellNoteId));
      if (WellId) formData.append('WellId', String(WellId));
      if (WellGroupId) formData.append('WellGroupId', String(WellGroupId));

      formData.append('Note', Note || '');
      formData.append('WellNoteCreated', formattedDate);
      formData.append('WellNoteCategoryId', CategoryId ? String(CategoryId) : '');

      const url = WellId
        ? `/pumpchecker/Well/UpdateOrCreateWellNote?${formData.toString()}`
        : `/pumpchecker/Well/CreateWellNotesForWellGroup?${formData.toString()}`;

      console.log('API URL with params:', url);

      const requestPayload = createWrapperPayload('POST', url, formData.toString());

      const response = await api.post(wrapperConstants.router, requestPayload);

      if (response?.status === 200 && response.data?.Success === 'true') {
        const event: WellEventData = {
          id: `manual-${Date.now()}`,
          wellId: WellId ?? null,
          wellGroupId: WellGroupId ?? null,
          categoryId: CategoryId,
          description: Note || '',
          timestamp: new Date().toISOString(),
          type: 'Note',
          source: 'manual',
          noteDate: noteDateObj.toISOString(),
        };
        return event;
      } else {
        return null;
      }
    } else {
      if (!assetId) return null;
      const payload = {
        "assetGuid": WellId ? String(WellId) : '',
        "id": WellNoteId ? String(WellNoteId) : '',
        "date": formattedDate,
        "eventTypeId": CategoryId,
        "note": wellNoteData.Note || ''
      }
      const response = await api.post('/Comments/add', payload)
      if (response?.status === 200) {
        const event: WellEventData = {
          id: `manual-${Date.now()}`,
          wellId: assetId ?? null,
          wellGroupId: WellGroupId ?? null,
          categoryId: CategoryId,
          description: Note || '',
          timestamp: new Date().toISOString(),
          type: 'Note',
          source: 'manual',
          noteDate: noteDateObj.toISOString(),
        };
        return event;
      } else {
        return null;
      }
    }
  } catch (error) {
    return null;
  }
};

const formatNoteDate = (inputDate: string | Date): string => {
  const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  if (isNaN(date.getTime())) {
    console.warn('Invalid date provided to formatNoteDate:', inputDate);
    return '';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Numeric month (01-12)
  const year = date.getFullYear();

  const formatted = `${year}-${month}-${day}`;
  return formatted;
};

export const deleteWellNote = async (wellNoteId: number | string, isPC: boolean): Promise<boolean> => {
  try {
    const formData = new URLSearchParams();
    formData.append('WellNoteId', String(wellNoteId));

    const url = `/pumpchecker/Well/DeleteWellNote?${formData.toString()}`;
    console.log('Delete API URL with params:', url);

    const requestPayload = createWrapperPayload('POST', url, formData.toString());

    const response = isPC ? await api.post(wrapperConstants.router, requestPayload) :
      await api.delete(`/Comments/${wellNoteId}`);

    if (response?.status === 200 && response.data) {
      console.log('Well comment deleted successfully');
      return true;
    } else {
      console.error('Failed to delete well comment:', response.data);
      return false;
    }
  } catch (error) {
    console.error('Error deleting well note:', error);
    return false;
  }
};
